export const styles = {
  container: {
    gap: '5',
    width: 'md',
  },
  title: {
    marginX: '5',
    fontSize: '2xl',
    textAlign: 'center',
  },
  document: {
    rowGap: '2',
    columnGap: '5',
    marginX: '5',
    justifySelf: 'center',
    gridTemplateColumns: { base: '56px 1fr', md: '56px 250px' },
  },
  image: {
    boxSize: '16',
    alignSelf: 'start',
    justifySelf: 'end',
    gridArea: '2 / 1 / span 2 / 1',
  },
  subtitle: {
    fontSize: 'lg',
    color: 'gray.700',
    gridArea: '2 / 2 / 2 / 3',
  },
  description: {
    color: 'gray.500',
    alignSelf: 'start',
    gridArea: '3 / 2 / 3 / 3',
  },
  notice: {
    marginX: '5',
    textAlign: 'center',
  },
  content: {

  },
  actions: {
    gap: '5',
    paddingX: '10',
    justifyContent: 'space-between',
  },
};
